import { useTranslation } from "react-i18next";

export function LocationMapPreview({
  address,
  browserKey,
}: {
  address: string;
  browserKey: string | null;
}) {
  const { t, i18n } = useTranslation();
  const query = address.trim();
  const source =
    browserKey && query
      ? `https://www.google.com/maps/embed/v1/place?${new URLSearchParams({ key: browserKey, q: query, language: i18n.language })}`
      : null;
  return (
    <section className="space-y-2" aria-label={t("maps.title")}>
      <h3 className="text-sm font-medium">{t("maps.title")}</h3>
      {source ? (
        <>
          <iframe
            title={t("maps.title")}
            src={source}
            className="h-72 w-full rounded-md border"
            loading="lazy"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
          <p className="text-muted-foreground text-sm">{t("maps.notice")}</p>
        </>
      ) : (
        <p className="text-muted-foreground text-sm" role="status">
          {t(browserKey ? "maps.address_hint" : "maps.unavailable")}
        </p>
      )}
    </section>
  );
}
